import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { SearchItem } from '@/feature/map/hooks/useAutoCompleteLocationSearch'
import { usePersistentObservatoryPageStore } from '@/feature/observatory/store/usePersistentObservatoryPageStore'

/**
 * Mirrors the shared search location onto the form's address field, and into the caller's
 * simulated position so the shape follows the search result.
 */
export const useUpdateAddressFromSearch = (
  setSimulatedPosition: (s: SearchItem | undefined) => void,
) => {
  const { setValue, resetField } = useFormContext()
  const searchLocation = usePersistentObservatoryPageStore((state) => state.searchLocation)

  useEffect(() => {
    if (searchLocation) {
      setSimulatedPosition(searchLocation)
    }
    if (searchLocation?.address) {
      setValue('geoFence.address', searchLocation?.address, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      })
    } else {
      resetField('geoFence.address')
    }
  }, [searchLocation])
}
